export default "__VITE_ASSET__5c09de54__"